type Token = {
    type: 'text' | 'key',
    value: string
}

type Keys = {
    name: string,
    start: number,
    length: number,
    end: number
}

export class I18NFormatter {

    private options!: object

    private _caches: { [key: string]: Array<Token> }

    constructor (options: object = {}) {
        this.options = options
        this._caches = {}
    }

    public interpolate (message: string, values: object) {
        if (!values) {
            return [message]
        } else {
            let tokens: Array<Token> = this._caches[message]
            if (!tokens) {
                tokens = this.tokenize(message)
                this._caches[message] = tokens
            }

            return this.compile(tokens, values);
        }
    }

    private tokenize(message: string): Array<Token> {
        let re = /###([^#]+)###/g;

        let keys: Array<Keys> = [];
        let m
        while (m = re.exec(message)) {
            keys.push({
                name: m[1],
                start: m['index'],
                length: m[0].length,
                end: m['index'] + m[0].length
            });
        }

        if (keys.length == 0) {
            return [{type: 'text', value: message}]
        } else {
            let tokens: Array<Token> = []

            keys.forEach((match, idx) => {
                let prefixBegin = 0
                if (idx > 0) {
                    prefixBegin = keys[idx-1].end
                }
                let prefix = message.substring(prefixBegin, match.start)
                if (prefix.length > 0) {
                    tokens.push({
                        type: 'text',
                        value: prefix
                    })
                }

                tokens.push({
                    type: 'key',
                    value: match.name
                })
            })

            let suffix = message.substring(keys[keys.length - 1 ].end)
            if (suffix.length > 0) {
                tokens.push({
                    type: 'text',
                    value: suffix
                })
            }

            return tokens
        }
    }

    private compile(tokens: Array<Token>, values: object): Array<any> {
        const compiled: Array<any> = []

        tokens.forEach(token => {
            switch (token.type) {
                case 'text':
                    compiled.push(token.value)
                    break;
                case 'key':
                    compiled.push(values[token.value])
                    break;
            }
        })

        return compiled
    }
}